const Renderer = require('../Renderer');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');
/**
 * 要素渲染
 * @ignore
 * @param {Object} options - 构造参数；
 * @param {G.Map} options.map - 地图对象
 * @param {String} options.layerId
 * @param {String} options.layerName
 * @param {Object} options.featureBuilder
 * @example
 * //使用示例代码
 * //todo
 */
let renderer = Renderer.extend({
    options: {},
    initialize(options) {
        Renderer.prototype.initialize.call(this, options);
        //
        this.options.geometryType = this.options.geometryType || 'point';
        //初始化点线面图层组
        this.options.map.initialGroupLayers();
        //
        this.featureLayerList = [];
        //
        this.layer = new g2.carto.GroupLayer({
            id: options.id,
            name: options.name,
            layers: [],
            zIndex: this.options.zIndex,
        });
        LayerUtil.addLayer2Group(this.options.map, this.layer, this.options.geometryType);
    },

    /**
     */
    destroy() {
        this.clear();
        this.layer.removeAllLayers();
        this.featureLayerList = null;
        LayerUtil.removeLayerFromGroup(this.options.map, this.layer, this.options.geometryType);
        Renderer.prototype.destroy.call(this);
    },

    /**
     *
     * @returns {*}
     */
    getLayer() {
        return this.layer;
    },
    /**
     *
     */
    getExtent() {
        return LayerUtil.getLayerExtent(this.layer);
    },
    add(list) {
        let startTime = new Date().getTime();
        let len = list.length;
        for (let i = 0; i < len; i++) {
            let item = list[i];
            let feature = this.options.featureBuilder.buildFeature(item, true);
            let featureLayerObj = this._getFeatureLayerObj(item);
            featureLayerObj.featureSet.add(feature);
        }
        // render
        this._render();
        //
        console.debug(list.length + ' features takes ' + (new Date().getTime() - startTime) + 'ms');
    },


    /**
     *
     * @param list
     */
    update(list) {
        let len = list.length;
        this.clearLayerOnly();
        for (let i = 0; i < len; i++) {
            let item = list[i];
            let feature = this.options.featureBuilder.buildFeature(item, true);
            let findResult = this._getFeatureById(feature.objectId);
            if (findResult.index >= 0) {
                findResult.featureLayerObj.featureSet.features.splice(findResult.index, 1);
            }
            let featureLayerObj = this._getFeatureLayerObj(item);
            featureLayerObj.featureSet.add(feature);
        }
        this._render();
    },

    /***
     * 移除指定要素
     * @param id
     */
    remove(id) {
        let findResult = this._getFeatureById(feature.objectId);
        if (findResult.index >= 0) {
            findResult.featureLayerObj.featureSet.features.splice(findResult.index, 1);
        }
        findResult.featureLayerObj.layer.clear();
        let renderer = new g2.render.SimpleRenderer({
            symbol: featureLayerObj.symbol
        });
        featureLayerObj.layer.addFeatures(featureLayerObj.featureSet);
        featureLayerObj.layer.render(renderer);
    },

    _render() {
        for (let i = 0, len = this.featureLayerList.length; i < len; i++) {
            let featureLayerObj = this.featureLayerList[i];
            let renderer = new g2.render.SimpleRenderer({
                symbol: featureLayerObj.symbol
            });
            featureLayerObj.layer.addFeatures(featureLayerObj.featureSet);
            featureLayerObj.layer.setVisible(true);
            featureLayerObj.layer.render(renderer);
        };
    },

    //
    _getFeatureLayerObj(data) {
        let symbol = this.options.featureBuilder.buildSymbol(data);
        let featureLayerObj = this._getFeatureObjBySymbol(symbol);
        if (featureLayerObj == null) {
            featureLayerObj = {};
            let featureLayer = new g2.carto.FeatureLayer({
                id: "featureLayer-" + CommonUtil.newUUID32(),
                opacity: 1.0,
                visible: false,
                zIndex: this.options.zIndex,
            });
            featureLayerObj.symbol = symbol;
            featureLayerObj.layer = featureLayer;
            featureLayerObj.featureSet = new g2.sfs.FeatureSet();
            this.layer.addLayer(featureLayer);
            this.featureLayerList.push(featureLayerObj);
        }
        return featureLayerObj;
    },

    //
    _getFeatureObjBySymbol(symbol) {
        let featureObj = null;
        for (let i = 0, len = this.featureLayerList.length; i < len; i++) {
            let symbolExist = this.featureLayerList[i].symbol;
            //判断符号是否相等
            if (symbolExist === symbol) {
                featureObj = this.featureLayerList[i];
                break;
            }
            let flag = true;
            for (let key in symbolExist) {
                if (symbolExist[key] != symbol[key]) {
                    flag = false;
                    continue;
                }
            }
            if (flag) {
                featureObj = this.featureLayerList[i];
                break;
            }
        }
        return featureObj;
    },

    //
    _getFeatureById(id) {
        let resultObj = {
            index: -1
        };
        for (let i = 0, len = this.featureLayerList.length; i < len; i++) {
            let featureLayerObj = this.featureLayerList[i];
            for (let j = 0; j < featureLayerObj.featureSet.getCount(); j++) {
                if (id == featureLayerObj.featureSet.getFeature(j).objectId) {
                    resultObj.featureLayerObj = featureLayerObj;
                    resultObj.index = j;
                    resultObj.feature = featureLayerObj.featureSet.getFeature(j);
                    break;
                }
            }
            if (resultObj.index >= 0) {
                break;
            }
        }
        return resultObj;
    },

    clearLayerOnly() {
        for (let i = 0; i < this.layer.groupLayers.length; i++) {
            this.layer.groupLayers[i].clear();
        }
        this.layer.clear();
    },

    clear() {
        this.clearLayerOnly();
        //clear data
        for (let i = 0, len = this.featureLayerList.length; i < len; i++) {
            let featureLayerObj = this.featureLayerList[i];
            featureLayerObj.featureSet.features = [];
        }
    },

    /**
     */
    setVisible(visible) {
        this.layer.setVisible(!!visible);
    },

    /**
     */
    getVisible() {
        return this.layer.visible;
    }
});

module.exports = renderer;